/* @generated from adl module kachemedia.specsheet.eventlog */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_db from './../../common/db';
import * as kachemedia_specsheet_db from './db';

export enum EventLogType {
  SHARED_CAMPAIGN_EXCEL_DOWNLOAD,
  SYSTEM_GENERATED,
  CAMPAIGN_SHARED_EMAIL_SENT,
  CAMPAIGN_CREATED,
  CAMPAIGN_UPDATED,
  CAMPAIGN_DELETED,
  BOOKING_ADDED,
  BOOKING_UPDATED,
  BOOKING_DELETED,
  PLACEMENT_ADDED,
  PLACEMENT_UPDATED,
  PLACEMENT_DELETED,
  CAMPAIGN_TEMPLATE_CREATED,
  CAMPAIGN_TEMPLATE_UPDATED,
  CAMPAIGN_TEMPLATE_DELETED,
}

const EventLogType_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.eventlog","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"SHARED_CAMPAIGN_EXCEL_DOWNLOAD","default":{"kind":"nothing"},"name":"SHARED_CAMPAIGN_EXCEL_DOWNLOAD","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"SYSTEM_GENERATED","default":{"kind":"nothing"},"name":"SYSTEM_GENERATED","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"CAMPAIGN_SHARED_EMAIL_SENT","default":{"kind":"nothing"},"name":"CAMPAIGN_SHARED_EMAIL_SENT","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"CAMPAIGN_CREATED","default":{"kind":"nothing"},"name":"CAMPAIGN_CREATED","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"CAMPAIGN_UPDATED","default":{"kind":"nothing"},"name":"CAMPAIGN_UPDATED","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"CAMPAIGN_DELETED","default":{"kind":"nothing"},"name":"CAMPAIGN_DELETED","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"BOOKING_ADDED","default":{"kind":"nothing"},"name":"BOOKING_ADDED","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"BOOKING_UPDATED","default":{"kind":"nothing"},"name":"BOOKING_UPDATED","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"BOOKING_DELETED","default":{"kind":"nothing"},"name":"BOOKING_DELETED","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"PLACEMENT_ADDED","default":{"kind":"nothing"},"name":"PLACEMENT_ADDED","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"PLACEMENT_UPDATED","default":{"kind":"nothing"},"name":"PLACEMENT_UPDATED","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"PLACEMENT_DELETED","default":{"kind":"nothing"},"name":"PLACEMENT_DELETED","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"CAMPAIGN_TEMPLATE_CREATED","default":{"kind":"nothing"},"name":"CAMPAIGN_TEMPLATE_CREATED","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"CAMPAIGN_TEMPLATE_UPDATED","default":{"kind":"nothing"},"name":"CAMPAIGN_TEMPLATE_UPDATED","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"CAMPAIGN_TEMPLATE_DELETED","default":{"kind":"nothing"},"name":"CAMPAIGN_TEMPLATE_DELETED","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"EventLogType","version":{"kind":"nothing"}}};

export const snEventLogType: ADL.ScopedName = {moduleName:"kachemedia.specsheet.eventlog", name:"EventLogType"};

export function texprEventLogType(): ADL.ATypeExpr<EventLogType> {
  return {value : {typeRef : {kind: "reference", value : snEventLogType}, parameters : []}};
}

export enum EventLogStatusType {
  PENDING,
  PROCESSED,
}

const EventLogStatusType_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.eventlog","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"PENDING","default":{"kind":"nothing"},"name":"PENDING","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"PROCESSED","default":{"kind":"nothing"},"name":"PROCESSED","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"EventLogStatusType","version":{"kind":"nothing"}}};

export const snEventLogStatusType: ADL.ScopedName = {moduleName:"kachemedia.specsheet.eventlog", name:"EventLogStatusType"};

export function texprEventLogStatusType(): ADL.ATypeExpr<EventLogStatusType> {
  return {value : {typeRef : {kind: "reference", value : snEventLogStatusType}, parameters : []}};
}

export interface SharedExcelDownloadData {
  requestingUserId: (common_db.DbKey<kachemedia_specsheet_db.AppUser>|null);
  campaignOrganisationId: common_db.DbKey<kachemedia_specsheet_db.Organisation>;
  campaignId: common_db.DbKey<kachemedia_specsheet_db.Campaign>;
}

export function makeSharedExcelDownloadData(
  input: {
    requestingUserId: (common_db.DbKey<kachemedia_specsheet_db.AppUser>|null),
    campaignOrganisationId: common_db.DbKey<kachemedia_specsheet_db.Organisation>,
    campaignId: common_db.DbKey<kachemedia_specsheet_db.Campaign>,
  }
): SharedExcelDownloadData {
  return {
    requestingUserId: input.requestingUserId,
    campaignOrganisationId: input.campaignOrganisationId,
    campaignId: input.campaignId,
  };
}

const SharedExcelDownloadData_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.eventlog","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"requestingUserId","default":{"kind":"nothing"},"name":"requestingUserId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"AppUser"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"campaignOrganisationId","default":{"kind":"nothing"},"name":"campaignOrganisationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Organisation"}},"parameters":[]}]}},{"annotations":[],"serializedName":"campaignId","default":{"kind":"nothing"},"name":"campaignId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Campaign"}},"parameters":[]}]}}]}},"name":"SharedExcelDownloadData","version":{"kind":"nothing"}}};

export const snSharedExcelDownloadData: ADL.ScopedName = {moduleName:"kachemedia.specsheet.eventlog", name:"SharedExcelDownloadData"};

export function texprSharedExcelDownloadData(): ADL.ATypeExpr<SharedExcelDownloadData> {
  return {value : {typeRef : {kind: "reference", value : snSharedExcelDownloadData}, parameters : []}};
}

export interface EventLogData_SharedExcelDownloadData {
  kind: 'sharedExcelDownloadData';
  value: SharedExcelDownloadData;
}
export interface EventLogData_NoData {
  kind: 'noData';
}

export type EventLogData = EventLogData_SharedExcelDownloadData | EventLogData_NoData;

export interface EventLogDataOpts {
  sharedExcelDownloadData: SharedExcelDownloadData;
  noData: null;
}

export function makeEventLogData<K extends keyof EventLogDataOpts>(kind: K, value: EventLogDataOpts[K]) { return {kind, value}; }

const EventLogData_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.eventlog","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"sharedExcelDownloadData","default":{"kind":"nothing"},"name":"sharedExcelDownloadData","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.eventlog","name":"SharedExcelDownloadData"}},"parameters":[]}},{"annotations":[],"serializedName":"noData","default":{"kind":"nothing"},"name":"noData","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"EventLogData","version":{"kind":"nothing"}}};

export const snEventLogData: ADL.ScopedName = {moduleName:"kachemedia.specsheet.eventlog", name:"EventLogData"};

export function texprEventLogData(): ADL.ATypeExpr<EventLogData> {
  return {value : {typeRef : {kind: "reference", value : snEventLogData}, parameters : []}};
}

export interface EventLog {
  sourceUserId: (common_db.DbKey<kachemedia_specsheet_db.AppUser>|null);
  sourceOrganisationId: (common_db.DbKey<kachemedia_specsheet_db.Organisation>|null);
  userId: (common_db.DbKey<kachemedia_specsheet_db.AppUser>|null);
  organisationId: (common_db.DbKey<kachemedia_specsheet_db.Organisation>|null);
  workspaceId: (common_db.DbKey<kachemedia_specsheet_db.Workspace>|null);
  campaignId: (common_db.DbKey<kachemedia_specsheet_db.Campaign>|null);
  eventType: EventLogType;
  data: EventLogData;
  status: EventLogStatusType;
  created: common.Instant;
  updated: common.Instant;
}

export function makeEventLog(
  input: {
    sourceUserId: (common_db.DbKey<kachemedia_specsheet_db.AppUser>|null),
    sourceOrganisationId: (common_db.DbKey<kachemedia_specsheet_db.Organisation>|null),
    userId: (common_db.DbKey<kachemedia_specsheet_db.AppUser>|null),
    organisationId: (common_db.DbKey<kachemedia_specsheet_db.Organisation>|null),
    workspaceId: (common_db.DbKey<kachemedia_specsheet_db.Workspace>|null),
    campaignId: (common_db.DbKey<kachemedia_specsheet_db.Campaign>|null),
    eventType: EventLogType,
    data: EventLogData,
    status: EventLogStatusType,
    created?: common.Instant,
    updated?: common.Instant,
  }
): EventLog {
  return {
    sourceUserId: input.sourceUserId,
    sourceOrganisationId: input.sourceOrganisationId,
    userId: input.userId,
    organisationId: input.organisationId,
    workspaceId: input.workspaceId,
    campaignId: input.campaignId,
    eventType: input.eventType,
    data: input.data,
    status: input.status,
    created: input.created === undefined ? 0 : input.created,
    updated: input.updated === undefined ? 0 : input.updated,
  };
}

const EventLog_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.eventlog","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["userId"],["organisationId"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"sourceUserId","default":{"kind":"nothing"},"name":"sourceUserId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"AppUser"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"sourceOrganisationId","default":{"kind":"nothing"},"name":"sourceOrganisationId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Organisation"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"userId","default":{"kind":"nothing"},"name":"userId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"AppUser"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"organisationId","default":{"kind":"nothing"},"name":"organisationId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Organisation"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"workspaceId","default":{"kind":"nothing"},"name":"workspaceId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Workspace"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"campaignId","default":{"kind":"nothing"},"name":"campaignId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Campaign"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"eventType","default":{"kind":"nothing"},"name":"eventType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.eventlog","name":"EventLogType"}},"parameters":[]}},{"annotations":[],"serializedName":"data","default":{"kind":"nothing"},"name":"data","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.eventlog","name":"EventLogData"}},"parameters":[]}},{"annotations":[],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.eventlog","name":"EventLogStatusType"}},"parameters":[]}},{"annotations":[],"serializedName":"created","default":{"kind":"just","value":0},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updated","default":{"kind":"just","value":0},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"EventLog","version":{"kind":"nothing"}}};

export const snEventLog: ADL.ScopedName = {moduleName:"kachemedia.specsheet.eventlog", name:"EventLog"};

export function texprEventLog(): ADL.ATypeExpr<EventLog> {
  return {value : {typeRef : {kind: "reference", value : snEventLog}, parameters : []}};
}

export enum MetricType {
  BasicByCreationDate,
}

const MetricType_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.eventlog","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"BasicByCreationDate","default":{"kind":"nothing"},"name":"BasicByCreationDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"MetricType","version":{"kind":"nothing"}}};

export const snMetricType: ADL.ScopedName = {moduleName:"kachemedia.specsheet.eventlog", name:"MetricType"};

export function texprMetricType(): ADL.ATypeExpr<MetricType> {
  return {value : {typeRef : {kind: "reference", value : snMetricType}, parameters : []}};
}

export interface IntervalFilter {
  dateStart: common.Instant;
  dateFinish: common.Instant;
}

export function makeIntervalFilter(
  input: {
    dateStart: common.Instant,
    dateFinish: common.Instant,
  }
): IntervalFilter {
  return {
    dateStart: input.dateStart,
    dateFinish: input.dateFinish,
  };
}

const IntervalFilter_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.eventlog","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"dateStart","default":{"kind":"nothing"},"name":"dateStart","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"dateFinish","default":{"kind":"nothing"},"name":"dateFinish","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"IntervalFilter","version":{"kind":"nothing"}}};

export const snIntervalFilter: ADL.ScopedName = {moduleName:"kachemedia.specsheet.eventlog", name:"IntervalFilter"};

export function texprIntervalFilter(): ADL.ATypeExpr<IntervalFilter> {
  return {value : {typeRef : {kind: "reference", value : snIntervalFilter}, parameters : []}};
}

export enum GroupByIntervals {
  MONTHS,
  DAYS,
}

const GroupByIntervals_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.eventlog","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"MONTHS","default":{"kind":"nothing"},"name":"MONTHS","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"DAYS","default":{"kind":"nothing"},"name":"DAYS","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"GroupByIntervals","version":{"kind":"nothing"}}};

export const snGroupByIntervals: ADL.ScopedName = {moduleName:"kachemedia.specsheet.eventlog", name:"GroupByIntervals"};

export function texprGroupByIntervals(): ADL.ATypeExpr<GroupByIntervals> {
  return {value : {typeRef : {kind: "reference", value : snGroupByIntervals}, parameters : []}};
}

export interface MetricGroupFilter {
  interval: (IntervalFilter|null);
  groupByIntervals: GroupByIntervals;
}

export function makeMetricGroupFilter(
  input: {
    interval: (IntervalFilter|null),
    groupByIntervals: GroupByIntervals,
  }
): MetricGroupFilter {
  return {
    interval: input.interval,
    groupByIntervals: input.groupByIntervals,
  };
}

const MetricGroupFilter_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.eventlog","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"interval","default":{"kind":"nothing"},"name":"interval","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.eventlog","name":"IntervalFilter"}},"parameters":[]}]}},{"annotations":[],"serializedName":"groupByIntervals","default":{"kind":"nothing"},"name":"groupByIntervals","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.eventlog","name":"GroupByIntervals"}},"parameters":[]}}]}},"name":"MetricGroupFilter","version":{"kind":"nothing"}}};

export const snMetricGroupFilter: ADL.ScopedName = {moduleName:"kachemedia.specsheet.eventlog", name:"MetricGroupFilter"};

export function texprMetricGroupFilter(): ADL.ATypeExpr<MetricGroupFilter> {
  return {value : {typeRef : {kind: "reference", value : snMetricGroupFilter}, parameters : []}};
}

export interface MetricSetFilter {
  eventTypes: EventLogType[];
  sourceUserIds: common_db.DbKey<kachemedia_specsheet_db.AppUser>[];
  sourceOrganisationIds: common_db.DbKey<kachemedia_specsheet_db.Organisation>[];
  userIds: common_db.DbKey<kachemedia_specsheet_db.AppUser>[];
  organisationIds: common_db.DbKey<kachemedia_specsheet_db.Organisation>[];
  campaignIds: common_db.DbKey<kachemedia_specsheet_db.Campaign>[];
}

export function makeMetricSetFilter(
  input: {
    eventTypes: EventLogType[],
    sourceUserIds?: common_db.DbKey<kachemedia_specsheet_db.AppUser>[],
    sourceOrganisationIds?: common_db.DbKey<kachemedia_specsheet_db.Organisation>[],
    userIds?: common_db.DbKey<kachemedia_specsheet_db.AppUser>[],
    organisationIds?: common_db.DbKey<kachemedia_specsheet_db.Organisation>[],
    campaignIds?: common_db.DbKey<kachemedia_specsheet_db.Campaign>[],
  }
): MetricSetFilter {
  return {
    eventTypes: input.eventTypes,
    sourceUserIds: input.sourceUserIds === undefined ? [] : input.sourceUserIds,
    sourceOrganisationIds: input.sourceOrganisationIds === undefined ? [] : input.sourceOrganisationIds,
    userIds: input.userIds === undefined ? [] : input.userIds,
    organisationIds: input.organisationIds === undefined ? [] : input.organisationIds,
    campaignIds: input.campaignIds === undefined ? [] : input.campaignIds,
  };
}

const MetricSetFilter_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.eventlog","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"eventTypes","default":{"kind":"nothing"},"name":"eventTypes","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.eventlog","name":"EventLogType"}},"parameters":[]}]}},{"annotations":[],"serializedName":"sourceUserIds","default":{"kind":"just","value":[]},"name":"sourceUserIds","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"AppUser"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"sourceOrganisationIds","default":{"kind":"just","value":[]},"name":"sourceOrganisationIds","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Organisation"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"userIds","default":{"kind":"just","value":[]},"name":"userIds","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"AppUser"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"organisationIds","default":{"kind":"just","value":[]},"name":"organisationIds","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Organisation"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"campaignIds","default":{"kind":"just","value":[]},"name":"campaignIds","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Campaign"}},"parameters":[]}]}]}}]}},"name":"MetricSetFilter","version":{"kind":"nothing"}}};

export const snMetricSetFilter: ADL.ScopedName = {moduleName:"kachemedia.specsheet.eventlog", name:"MetricSetFilter"};

export function texprMetricSetFilter(): ADL.ATypeExpr<MetricSetFilter> {
  return {value : {typeRef : {kind: "reference", value : snMetricSetFilter}, parameters : []}};
}

export interface MetricDateResult {
  date: common.Instant;
  value: number;
}

export function makeMetricDateResult(
  input: {
    date: common.Instant,
    value: number,
  }
): MetricDateResult {
  return {
    date: input.date,
    value: input.value,
  };
}

const MetricDateResult_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.eventlog","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"date","default":{"kind":"nothing"},"name":"date","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"value","default":{"kind":"nothing"},"name":"value","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"MetricDateResult","version":{"kind":"nothing"}}};

export const snMetricDateResult: ADL.ScopedName = {moduleName:"kachemedia.specsheet.eventlog", name:"MetricDateResult"};

export function texprMetricDateResult(): ADL.ATypeExpr<MetricDateResult> {
  return {value : {typeRef : {kind: "reference", value : snMetricDateResult}, parameters : []}};
}

export interface MetricCategoryResult {
  category: string;
  value: number;
}

export function makeMetricCategoryResult(
  input: {
    category: string,
    value: number,
  }
): MetricCategoryResult {
  return {
    category: input.category,
    value: input.value,
  };
}

const MetricCategoryResult_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.eventlog","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"category","default":{"kind":"nothing"},"name":"category","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"value","default":{"kind":"nothing"},"name":"value","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"MetricCategoryResult","version":{"kind":"nothing"}}};

export const snMetricCategoryResult: ADL.ScopedName = {moduleName:"kachemedia.specsheet.eventlog", name:"MetricCategoryResult"};

export function texprMetricCategoryResult(): ADL.ATypeExpr<MetricCategoryResult> {
  return {value : {typeRef : {kind: "reference", value : snMetricCategoryResult}, parameters : []}};
}

export interface MetricCalculationReq {
  metricType: MetricType;
  groupFilter: MetricGroupFilter;
  setFilters: MetricSetFilter[];
}

export function makeMetricCalculationReq(
  input: {
    metricType: MetricType,
    groupFilter: MetricGroupFilter,
    setFilters: MetricSetFilter[],
  }
): MetricCalculationReq {
  return {
    metricType: input.metricType,
    groupFilter: input.groupFilter,
    setFilters: input.setFilters,
  };
}

const MetricCalculationReq_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.eventlog","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"metricType","default":{"kind":"nothing"},"name":"metricType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.eventlog","name":"MetricType"}},"parameters":[]}},{"annotations":[],"serializedName":"groupFilter","default":{"kind":"nothing"},"name":"groupFilter","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.eventlog","name":"MetricGroupFilter"}},"parameters":[]}},{"annotations":[],"serializedName":"setFilters","default":{"kind":"nothing"},"name":"setFilters","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.eventlog","name":"MetricSetFilter"}},"parameters":[]}]}}]}},"name":"MetricCalculationReq","version":{"kind":"nothing"}}};

export const snMetricCalculationReq: ADL.ScopedName = {moduleName:"kachemedia.specsheet.eventlog", name:"MetricCalculationReq"};

export function texprMetricCalculationReq(): ADL.ATypeExpr<MetricCalculationReq> {
  return {value : {typeRef : {kind: "reference", value : snMetricCalculationReq}, parameters : []}};
}

export interface ByDateResultsInfo {
  groupByIntervals: GroupByIntervals;
}

export function makeByDateResultsInfo(
  input: {
    groupByIntervals: GroupByIntervals,
  }
): ByDateResultsInfo {
  return {
    groupByIntervals: input.groupByIntervals,
  };
}

const ByDateResultsInfo_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.eventlog","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"groupByIntervals","default":{"kind":"nothing"},"name":"groupByIntervals","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.eventlog","name":"GroupByIntervals"}},"parameters":[]}}]}},"name":"ByDateResultsInfo","version":{"kind":"nothing"}}};

export const snByDateResultsInfo: ADL.ScopedName = {moduleName:"kachemedia.specsheet.eventlog", name:"ByDateResultsInfo"};

export function texprByDateResultsInfo(): ADL.ATypeExpr<ByDateResultsInfo> {
  return {value : {typeRef : {kind: "reference", value : snByDateResultsInfo}, parameters : []}};
}

export interface ByDateResults {
  data: MetricDateResult[][];
  info: ByDateResultsInfo;
}

export function makeByDateResults(
  input: {
    data: MetricDateResult[][],
    info: ByDateResultsInfo,
  }
): ByDateResults {
  return {
    data: input.data,
    info: input.info,
  };
}

const ByDateResults_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.eventlog","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"data","default":{"kind":"nothing"},"name":"data","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.eventlog","name":"MetricDateResult"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"info","default":{"kind":"nothing"},"name":"info","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.eventlog","name":"ByDateResultsInfo"}},"parameters":[]}}]}},"name":"ByDateResults","version":{"kind":"nothing"}}};

export const snByDateResults: ADL.ScopedName = {moduleName:"kachemedia.specsheet.eventlog", name:"ByDateResults"};

export function texprByDateResults(): ADL.ATypeExpr<ByDateResults> {
  return {value : {typeRef : {kind: "reference", value : snByDateResults}, parameters : []}};
}

export interface ByCategoryResults {
  data: MetricCategoryResult[][];
}

export function makeByCategoryResults(
  input: {
    data: MetricCategoryResult[][],
  }
): ByCategoryResults {
  return {
    data: input.data,
  };
}

const ByCategoryResults_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.eventlog","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"data","default":{"kind":"nothing"},"name":"data","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.eventlog","name":"MetricCategoryResult"}},"parameters":[]}]}]}}]}},"name":"ByCategoryResults","version":{"kind":"nothing"}}};

export const snByCategoryResults: ADL.ScopedName = {moduleName:"kachemedia.specsheet.eventlog", name:"ByCategoryResults"};

export function texprByCategoryResults(): ADL.ATypeExpr<ByCategoryResults> {
  return {value : {typeRef : {kind: "reference", value : snByCategoryResults}, parameters : []}};
}

export interface MetricResultRes_ByDate {
  kind: 'byDate';
  value: ByDateResults;
}
export interface MetricResultRes_ByCategory {
  kind: 'byCategory';
  value: ByCategoryResults;
}
export interface MetricResultRes_Error {
  kind: 'error';
  value: string;
}

export type MetricResultRes = MetricResultRes_ByDate | MetricResultRes_ByCategory | MetricResultRes_Error;

export interface MetricResultResOpts {
  byDate: ByDateResults;
  byCategory: ByCategoryResults;
  error: string;
}

export function makeMetricResultRes<K extends keyof MetricResultResOpts>(kind: K, value: MetricResultResOpts[K]) { return {kind, value}; }

const MetricResultRes_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.eventlog","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"byDate","default":{"kind":"nothing"},"name":"byDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.eventlog","name":"ByDateResults"}},"parameters":[]}},{"annotations":[],"serializedName":"byCategory","default":{"kind":"nothing"},"name":"byCategory","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.eventlog","name":"ByCategoryResults"}},"parameters":[]}},{"annotations":[],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"MetricResultRes","version":{"kind":"nothing"}}};

export const snMetricResultRes: ADL.ScopedName = {moduleName:"kachemedia.specsheet.eventlog", name:"MetricResultRes"};

export function texprMetricResultRes(): ADL.ATypeExpr<MetricResultRes> {
  return {value : {typeRef : {kind: "reference", value : snMetricResultRes}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "kachemedia.specsheet.eventlog.EventLogType" : EventLogType_AST,
  "kachemedia.specsheet.eventlog.EventLogStatusType" : EventLogStatusType_AST,
  "kachemedia.specsheet.eventlog.SharedExcelDownloadData" : SharedExcelDownloadData_AST,
  "kachemedia.specsheet.eventlog.EventLogData" : EventLogData_AST,
  "kachemedia.specsheet.eventlog.EventLog" : EventLog_AST,
  "kachemedia.specsheet.eventlog.MetricType" : MetricType_AST,
  "kachemedia.specsheet.eventlog.IntervalFilter" : IntervalFilter_AST,
  "kachemedia.specsheet.eventlog.GroupByIntervals" : GroupByIntervals_AST,
  "kachemedia.specsheet.eventlog.MetricGroupFilter" : MetricGroupFilter_AST,
  "kachemedia.specsheet.eventlog.MetricSetFilter" : MetricSetFilter_AST,
  "kachemedia.specsheet.eventlog.MetricDateResult" : MetricDateResult_AST,
  "kachemedia.specsheet.eventlog.MetricCategoryResult" : MetricCategoryResult_AST,
  "kachemedia.specsheet.eventlog.MetricCalculationReq" : MetricCalculationReq_AST,
  "kachemedia.specsheet.eventlog.ByDateResultsInfo" : ByDateResultsInfo_AST,
  "kachemedia.specsheet.eventlog.ByDateResults" : ByDateResults_AST,
  "kachemedia.specsheet.eventlog.ByCategoryResults" : ByCategoryResults_AST,
  "kachemedia.specsheet.eventlog.MetricResultRes" : MetricResultRes_AST
};
